import { CharacterMetadata, ContentState, EntityInstance } from 'draft-js';

export default (
  char: CharacterMetadata,
  contentState: ContentState,
): {
  entity: EntityInstance;
  entityKey: string;
  isFollowupEntity: boolean;
  isMentionEntity: boolean;
} => {
  const entityKey = char.getEntity();
  const entity = entityKey !== null && contentState.getEntity(entityKey);
  const isFollowupEntity = entity && entity.getType() == 'followup';
  const isMentionEntity = entity && entity.getType() == 'mention';

  return { entity, entityKey, isFollowupEntity, isMentionEntity };
};
